<template>
  <b-modal
    ref="insurance-modal-ref"
    hide-footer
    hide-header
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">Insurance</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <div
          class="message d-flex justify-content-center"
          v-for="(item, index) in insuranceSubItems"
          :key="index"
        >
          <div class="d-flex flex-column align-items-center">
            <p v-if="item.href">
              <span v-if="item.href.includes('.ie')">
               We recommend you have adequate travel insurance in place from the time you pay for your travel arrangements. Please contact our preferred partner Blue Insurance for a quote online <a href="https://whitelabel.blueinsurance.ie/?agentCode=5009">here</a> or by calling <a href="tel:0818414414">0818 414 414</a>. For general enquiries email <a href="mailto:info@blueinsurance.ie">info@blueinsurance.ie</a>.
              </span>
              <span v-else>
                {{ item.title }}
              </span>
              </p>
            <b-button 
              v-if="checkButton(item.title) && item.href" 
              :href="item.href"
              target="_blank"
              class="btn btn-info mb-3"
            >
              {{item.title === 'Trailfinders Travel Insurance' ? 'Get a Quote' : 'Download'}}
            </b-button>
          </div>
        </div>
        <!-- INS COVER NOTE BTN -->
        <div 
          v-if="insCoverNote && Object.keys(insCoverNote).length > 0"
          class="message d-flex flex-column align-items-center mt-4">
          <p>{{ insCoverNote.title }}</p>
          <b-button 
            class="btn btn-info"
            @click="getInsCoverNote"
          >
            Download
          </b-button>
        </div>
        <InsuranceCoverNote ref="InsuranceCoverNoteRef" />
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import InsuranceCoverNote from "@/modules/menu-bar/insurance-cover-note";

export default {
  components: {
    InsuranceCoverNote
  },
  data() {
     return {
      insuranceSubItems: [],
      insCoverNote: {}
    }
  },
  methods: {
    async showModal(insuranceObj) {
      this.$refs["insurance-modal-ref"].show();
      if(Object.keys(insuranceObj).length === 0) {
        return
      }
      if(insuranceObj && Array.isArray(insuranceObj.submenu)) {
        const hasInsCoverNote = insuranceObj.submenu.filter(item => item.title === 'Travel Insurance Policy Certificate')
        if(hasInsCoverNote) {
          this.insuranceSubItems = insuranceObj.submenu.filter(item => item.title !== 'Travel Insurance Policy Certificate')
          this.insCoverNote = hasInsCoverNote[0]
        } else {
          this.insuranceSubItems = insuranceObj.submenu
        }
      }
    },
    checkButton(_title){
      if(_title === 'Emergency Claims & Policy Document') {
        return true
      }else if(_title === 'IPID') {
        return true
      }else if(_title === 'Trailfinders Travel Insurance') {
        return true
      }
      return false
    },
    closeModal() {
      this.$refs["insurance-modal-ref"].hide();
    },
    getInsCoverNote() {
      this.$refs.InsuranceCoverNoteRef.getInsuranceCoverNotePDF();
    },
  },
  computed: {
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },

};
</script>
<style lang="scss">
</style>

